const initSwiper = () => {
  const speed = +document.documentElement.getAttribute('data-carousel-speed');
  console.log(speed);
  new Swiper('.gh-carousel', {
    loop: {
      delay: speed,
    },
    parallax: true,
    autoplay: true,
    pagination: {
      el: '.gh-carousel-pagination',
      clickable: true,
      bulletClass: 'gh-carousel-pagination-bullet',
      bulletActiveClass: 'gh-carousel-pagination-bullet-active',
      renderBullet: function (_, className) {
        return `<div class="${className}"><span></span></div>`;
      },
    },
    navigation: {
      prevEl: '.gh-carousel-button-prev',
      nextEl: '.gh-carousel-button-next',
    },
  });
};

const initCarousel = () => {
  if (document.querySelector('.gh-carousel')) {
    initSwiper();
  }
};

export { initCarousel };
